import type { DeviceObject } from "@features/devices/api";
import type { SelectProps } from "antd";
import { Select } from "antd";
import { useMemo } from "react";

export interface ObjectSelectValue {
  objectId: number;
  regionId: number;
}

const buildValue = (regionId: number, objectId: number) => `${regionId}:${objectId}`;

const parseValue = (raw?: string | number): ObjectSelectValue | undefined => {
  if (raw === undefined || raw === null || raw === "") {
    return undefined;
  }
  const [regionPart, objectPart] = raw.toString().split(":");
  const regionId = Number(regionPart);
  const objectId = Number(objectPart);
  if (Number.isNaN(regionId) || Number.isNaN(objectId)) {
    return undefined;
  }
  return { regionId, objectId };
};

interface ObjectSelectProps extends Omit<SelectProps<string>, "options" | "onChange" | "value"> {
  objects: DeviceObject[];
  value?: ObjectSelectValue;
  onChange?: (value?: ObjectSelectValue) => void;
}

const ObjectSelect = ({
  objects,
  value,
  onChange,
  placeholder = "Объект",
  showSearch = true,
  ...rest
}: ObjectSelectProps) => {
  const options = useMemo(
    () =>
      objects.map((obj) => ({
        label: `${obj.txt ?? "Без названия"} (№${obj.n_ob})`,
        value: buildValue(obj.syb_rnk, obj.n_ob),
      })),
    [objects],
  );

  const handleChange: SelectProps<string>["onChange"] = (rawValue) => {
    const parsed = parseValue(rawValue as string | number | undefined);
    onChange?.(parsed);
  };

  const selectedKey = value ? buildValue(value.regionId, value.objectId) : undefined;

  return (
    <Select<string>
      {...rest}
      showSearch={showSearch}
      placeholder={placeholder}
      optionFilterProp="label"
      options={options}
      value={selectedKey}
      onChange={handleChange}
    />
  );
};

export default ObjectSelect;
